import React from 'react';

function ColorPickerIcon() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			fill='none'
			viewBox='0 0 24 24'
		>
			<path
				fill='#FFA048'
				d='M13.435 7l-6.276 6.276L13.435 7zm-6.276 6.276l-2.332 2.332c-.901.901-1.352 1.352-1.59 1.925C3 18.107 3 18.744 3 20.02V21h.98c1.276 0 1.913 0 2.487-.237.573-.238 1.024-.689 1.925-1.59l5.897-5.897m-7.13 0h7.13-7.13zm7.13 0L17 10.565l-2.71 2.71z'
			></path>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='1.5'
				d='M13.435 7l-6.276 6.276m0 0l-2.332 2.332c-.901.901-1.352 1.352-1.59 1.925C3 18.107 3 18.744 3 20.02V21h.98c1.276 0 1.913 0 2.487-.237.573-.238 1.024-.689 1.925-1.59l5.897-5.897m-7.13 0h7.13m0 0L17 10.565M19.209 8.389L20.82 10m-1.611-1.611l.861-.862c.293-.293.44-.439.541-.582a2.099 2.099 0 000-2.434c-.102-.143-.248-.289-.54-.582-.293-.292-.44-.438-.582-.54a2.098 2.098 0 00-2.434 0c-.143.102-.29.248-.582.54l-.862.862M19.21 8.39L15.61 4.79m0 0L14 3.18'
			></path>
		</svg>
	);
}

export default ColorPickerIcon;
